const SITE_ORDER = ["google", "yelp", "bbb", "angi", "facebook"];

export function sortExternalRatingLinks(links = []) {
  return [...links].sort((a, b) => {
    const aIndex = SITE_ORDER.indexOf(a.site);
    const bIndex = SITE_ORDER.indexOf(b.site);
    return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
  });
}

export function formatExternalLinksUpdatedAt(value) {
  if (!value) return null;
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}